module.exports = {
      id: "astrology-usage",
      viewBox: "0 0 29.4 29.4",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#astrology",
      toString: function () {
        return this.url;
      }
    }